import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import IconButton from '@zenbusiness/zui/IconButton';
import InputAdornment from '@zenbusiness/zui/InputAdornment';

import { StyledTextField } from '../../VeloAIAssistant.styles';

export const LOCALIZED_TEXT = {
  placeholder: 'businessProfile.aiAssistant.inputPlaceholder'
};

function AssistantInput({
  disabled = false,
  onChange,
  onSend,
  value
}) {
  const { formatMessage: fm } = useIntl();
  const handleKeyDown = (e) => {
    const { shiftKey, key, target: { value: incomingValue } } = e;
    if (key === 'Enter' && !shiftKey && incomingValue.trim()) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <StyledTextField
      value={value}
      onChange={onChange}
      placeholder={fm({ id: LOCALIZED_TEXT.placeholder })}
      fullWidth
      multiline
      maxRows={4}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              disabled={!value || disabled}
              onClick={onSend}
              edge="end"
              label="Send"
              aria-label="Send"
            >
              <ArrowCircleUpIcon sx={{ width: '1.5rem', height: '1.5rem' }} />
            </IconButton>
          </InputAdornment>
        )
      }}
      onKeyDown={handleKeyDown}
    />
  );
}

AssistantInput.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

export default AssistantInput;
